// Step 22 — attention chips.
//
// One chip per deterministic observation from `buyerAttentionFlags`.
// Explicitly NOT a score — each chip is a distinct, explainable signal.

import { buyerAttentionFlags } from "./helpers";

export default function AIBuyerAttentionChips({ row, patternsForBuyer }) {
  const flags = buyerAttentionFlags(row, { patternsForBuyer });
  if (flags.length === 0) return null;
  return (
    <div className="qai-buyer-attention-chips">
      {flags.map((f) => (
        <span
          key={f.kind}
          className="qai-buyer-attention-chip"
          data-severity={f.severity}
          title={f.title}
        >
          {f.label}
        </span>
      ))}
    </div>
  );
}
